import { SupportPage } from './Support';

export default SupportPage;
